import p5 from "p5";

class ShoulderingStudy {




    constructor(sketch, w, h, ps, dp) {
        this.sketch = sketch;
        this.w = w;
        this.h = h;
        this.dp = dp;

        this.ps = ps;
        this.particles = ps.systemParticles();

        this.maxDistanceFromEpicenter = w;

        this.center = sketch.createVector(w / 2, h / 2);

        this.frameStart = sketch.frameCount;

        this.phaseNumber = 1;


        for (let i = 0; i < ps.systemParticles().length; i++) {
            let particle = ps.systemParticles()[i];

            particle.generateRandomValue(0, 1);

        }
    }

    reset() {
        this.frameStart = this.sketch.frameCount;

        this.phaseNumber = 1;


        for (let i = 0; i < this.ps.systemParticles().length; i++) {
            let particle = this.ps.systemParticles()[i];

            particle.generateRandomValue(0, 1);

        }

    }

    draw() {

        //sum = d.sum();
        this.sum = this.dp.sum();



        let mappedSum = this.sketch.map(this.sum, 0, 200, 0, 1, true);
        // mappedSum = this.sketch.constrain(mappedSum, 0, p5.HALF_PI);

        if (this.dp.shouldSwitchPhase() == true) {

            this.pushPhase();

        }


        // if (this.sum < 5) {

        // for (let i = 0; i < this.ps.systemParticles().length; i++) {
        //     let p = this.ps.systemParticles()[i];



        //     p.fixPosition(false);

        //     p.generateRandomValue(0, 1);
        // }
        // } else {


        for (let i = 0; i < this.ps.systemParticles().length; i++) {
            let p = this.ps.systemParticles()[i];

            let r = p.randomValue;

            if (r < mappedSum) {

                if (this.phaseNumber == 1) {
                    p.fixPositionY(false);
                    p.fixPositionX(true);
                } else if (this.phaseNumber == 2) {
                    p.fixPositionX(false);
                    p.fixPositionY(true);
                } else if (this.phaseNumber == 3) {
                    p.fixPosition(true);
                }
            } else {

                //if(p.isFixed == true) {

                //  p.resetOscillationFrameCount(frameCount);
                //}

                p.fixPosition(false);
            }
        }
        // }

        for (let i = 0; i < this.ps.systemParticles().length; i++) {
            let p = this.ps.systemParticles()[i];


            p.updateOscillationPosition();

            //if (p.isFixed == false) {
            //  if (p.isOscillationX || p.isOscillationY) {

            //    p.updateOscillationPosition();
            //  }
            //}
        }

        this.ps.render();
    }


    moveCenter(x, y) {
        this.center = this.sketch.createVector(x, y);
    }




    pushPhase() {

        if (this.phaseNumber < 3) {

            this.phaseNumber += 1;

            for (let i = 0; i < this.ps.systemParticles().length; i++) {
                let p = this.ps.systemParticles()[i];

                p.fixPosition(false);

                p.generateRandomValue(0, 1);
            }
        } else {

            this.phaseNumber = 1;

            for (let i = 0; i < this.ps.systemParticles().length; i++) {
                let p = this.ps.systemParticles()[i];


                p.fixPosition(false);

                p.generateRandomValue(0, 1);
            }
        }
    }
}

export default ShoulderingStudy;